<template>
  <div class="steps" style="width: 100%">
    <div :class="{ filled: progress > i, dark: dark }" class="step" v-for="(x, i) in steps" :key="i">
      <div class="tooltip">{{ x }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["opdracht", "dark"],
  data() {
    return {
      steps: ["nieuw", "in behandeling", "uitgezet", "geaccepteerd", "intake", "lopend", "gefactureerd"]
    }
  },

  setup(props) {
    console.log(props.opdracht.facturen.length)
    return {}
  },

  computed: {
    gearchiveerd() {
      return this.opdracht.gearchiveerd?.gearchiveerd
    },
    progress() {
      const status = this.opdracht.statusString
      if (this.opdracht.geannuleerd || this.opdracht.onhold || this.gearchiveerd) return 0
      if (status === "Nieuw") return 1
      if (status === "In behandeling") return 2
      if (status === "Uitgezet") return 3
      if (status === "Geaccepteerd") return 4
      if (status === "Intake") return 5
      if (status === "Gestart") return 6
      if (status === "Beëindigd") return 7
      return 0
    }
  }
}
</script>

<style lang="sass" scoped>

.steps
  display: flex

.step
  position: relative
  height: 10px
  width: calc( 100% / 7 )
  background-color: rgba(0, 0, 0, 0.08)
  &.dark
    background-color: #061932
  &:not(&:last-of-type)
    margin-right: 2px
  &:first-of-type
    border-radius: 20px 0 0 20px
  &:last-of-type
    border-radius: 0 20px 20px 0
  //
  &.filled
    background-color: hsl(210, 100%, 55%)

  &:hover
    .tooltip
      opacity: 1

  .tooltip
    text-transform: capitalize
    white-space: nowrap
    padding: 3px 5px
    font-weight: 500
    border-radius: 4px
    opacity: 0
    pointer-events: none
    font-size: 12px
    text-align: center
    color: white
    background-color: black
    position: absolute
    top: 150%
    left: 50%
    transform: translateX(-50%)
</style>
